import { useState, useEffect } from 'react';

export function useCountdown(targetMs) {
  const [timeLeft, setTimeLeft] = useState(() => Math.max(0, targetMs - Date.now()));

  useEffect(() => {
    const tick = () => setTimeLeft(Math.max(0, targetMs - Date.now()));
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  const d = Math.floor(timeLeft / 86400000);
  const h = Math.floor((timeLeft % 86400000) / 3600000);
  const m = Math.floor((timeLeft % 3600000) / 60000);
  const s = Math.floor((timeLeft % 60000) / 1000);

  return {
    days:    String(d).padStart(2, '0'),
    hours:   String(h).padStart(2, '0'),
    minutes: String(m).padStart(2, '0'),
    seconds: String(s).padStart(2, '0'),
  };
}
